<template>
	<v-card>
		<v-card-text>
			<v-form ref="form">
				<!-- <z-oferta></z-oferta> -->

				<v-checkbox 
					v-model="value"
					label="З умовами публічної оферти ознайомлений"
					hide-details
					single-line
				></v-checkbox>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'
//import zOferta from '@/components/Oferta'

export default {
	mixins: [mixin],
	components: {
		//zOferta
	},

	props: {
		modelValue:			{ type: Boolean, default: false },
	},
}
</script>
